import { Modal } from "react-bootstrap";
import { formatDate } from "../../utils/date";

const Field = ({ label, value }) => (
  <div className="col-md-6">
    <div className="text-muted small">{label}</div>
    <div className="fw-semibold">{value || "-"}</div>
  </div>
);

export const getLabDetails = (technician = {}) => technician.lab || technician.labInfo || {};
const getEducationDetails = (technician = {}) => technician.educationDetails || {};

// Collection radius exactly as saved from the technician app.
export const formatRadius = (technician = {}) => {
  const radius = technician.deliveryRadius;
  return radius === null || radius === undefined || radius === "" ? "Not set" : `${radius} km`;
};

const formatLatLong = (lab = {}) =>
  lab.hasLocation ? `${lab.latitude}, ${lab.longitude}` : "Not set";

// Service location the lab pin falls in (from the API), or why there is none.
export const formatServiceLocation = (technician = {}) => {
  const location = technician.serviceLocation;
  if (location?.name) return [location.name, location.city].filter(Boolean).join(", ");
  return getLabDetails(technician).hasLocation ? "Outside service locations" : "Lab location not set";
};

// `technician` is the admin lab-technician API shape; null hides the dialog.
const LabTechnicianDetailsModal = ({ technician, onHide }) => (
  <Modal show={Boolean(technician)} onHide={onHide} centered size="lg">
    <Modal.Header closeButton>
      <Modal.Title>Lab Technician Details</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {technician && (
        <div className="d-grid gap-4">
          <section>
            <div className="fw-semibold mb-2">Basic Details</div>
            <div className="row g-3">
              <Field label="Lab ID" value={technician.labId} />
              <Field label="Name" value={technician.fullName} />
              <Field label="Mobile" value={technician.mobileNumber} />
              <Field label="Email" value={technician.email} />
              <Field label="Total Orders" value={technician.totalOrders ?? 0} />
              <Field label="Created" value={formatDate(technician.createdAt)} />
              <Field label="Status" value={technician.isActive ? "Active" : "Inactive"} />
              <Field label="Approval" value={technician.isApproved ? "Completed" : "Pending"} />
            </div>
          </section>

          <section>
            <div className="fw-semibold mb-2">Lab Details</div>
            <div className="row g-3">
              <Field label="Lab Name" value={getLabDetails(technician).labName} />
              <Field label="Licence Number" value={getLabDetails(technician).licenceNumber} />
              <Field label="Address" value={[getLabDetails(technician).address1, getLabDetails(technician).address2].filter(Boolean).join(", ")} />
              <Field label="Landmark" value={getLabDetails(technician).landmark} />
              <Field label="Town / Village" value={getLabDetails(technician).town} />
              <Field label="City" value={getLabDetails(technician).city} />
              <Field label="Pincode" value={getLabDetails(technician).pincode} />
              <Field label="Lat / Long" value={formatLatLong(getLabDetails(technician))} />
              <Field label="Collection Radius" value={formatRadius(technician)} />
              <Field label="Service Location" value={formatServiceLocation(technician)} />
            </div>
          </section>

          <section>
            <div className="fw-semibold mb-2">Education Details</div>
            <div className="row g-3">
              <Field label="Higher Education" value={getEducationDetails(technician).higherEducation} />
              <Field label="Degree Name" value={getEducationDetails(technician).degreeName} />
              <Field label="Passing Year" value={getEducationDetails(technician).passingYear} />
              <Field label="Label" value={technician.labEducationLabel} />
            </div>
          </section>
        </div>
      )}
    </Modal.Body>
  </Modal>
);

export default LabTechnicianDetailsModal;
